import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'shared-form-for-add-voucher',
    templateUrl: './form-for-add-voucher.shared.component.html',
    styleUrls: ['./form-for-add-voucher.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormForAddVoucherComponent extends FormTypesComponent implements OnInit, OnDestroy {

    public isError$: Observable<boolean>;
    public errorMessage$: Observable<string[]>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
    ) {
        super(config, formBuilder);
        this.formName = 'add-voucher';
    }

    ngOnInit(): void {
        this.formControl = this.formBuilder.group({
            voucherCode: [
                {
                    value: '',
                    disabled: false
                },
                [
                    Validators.required,
                ]
            ],
        });
        this.isError$ = this.controllers.onlineOrders.isVoucherError$();
        this.errorMessage$ = this.controllers.onlineOrders.voucherErrorMessage$();

        this.onInit.emit(this.formControl);
    }

    ngOnDestroy(): void {
        this.formControl.reset();
    }
}
